export type ActiveFilterSyncActions = {
    add: Array<{ key: string; value: string[] }>;
    remove: string[];
};

const sameStringArrays = (current: string[] | undefined, next: string[]): boolean => {
    if (!current || current.length !== next.length) return false;
    const sortedCurrent = [...current].sort();
    const sortedNext = [...next].sort();
    return sortedCurrent.every((value, index) => value === sortedNext[index]);
};

/**
 * Diffs URL search params against list activeFilters for the given option keys.
 * URL is the source of truth: adds/updates keys present in the URL, and clears any
 * option key that is in activeFilters but absent from the URL (search chips, filters,
 * and timing params from chart navigation).
 */
export function getActiveFilterSyncFromSearchParams(
    searchParams: URLSearchParams,
    optionKeys: string[],
    currentActiveFilters: Record<string, string[]> | null | undefined
): ActiveFilterSyncActions {
    const add: ActiveFilterSyncActions['add'] = [];
    const remove: string[] = [];

    for (const key of optionKeys) {
        const params = searchParams.getAll(key);
        if (params.length > 0) {
            if (!sameStringArrays(currentActiveFilters?.[key], params)) {
                add.push({ key, value: params });
            }
            continue;
        }
        if ((currentActiveFilters?.[key]?.length ?? 0) > 0) {
            remove.push(key);
        }
    }

    return { add, remove };
}
